import { useFormField } from '../core';
import { FormInitialValues } from '../typings';

export const useFieldValue = (fieldId: string) => {
  const [field] = useFormField<FormInitialValues[string]>(fieldId);

  return field?.value;
};
